import numeral from 'numeral';
import CircularProgressCard from '../../lib/cards/CircularProgressCard';

export default class TicketQuantitySoldGoal extends CircularProgressCard {
  constructor(props) {
    super(props)
  }
  getMessage(difference) {
    return `You need to sell ${numeral(difference).format('0,0')} more tickets to reach your goal`;
  }
  getInitialValue() {
    return numeral(super.getInitialValue()).format('0,0');
  }
  getCurrentGoal() {
    let { goal } = this.state;
    if (goal !== undefined && goal !== null) {
        return numeral(this.state.goal).format('0,0');
    } else {
      return this.state.goal || '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/series/goalCards/TicketQuantitySoldGoal.js